export type CustomPlaceholderTokens = {
	fontWeight: number;
	color: string;
};

export default {
	fontWeight: 700,
	color: '{primary.300}',
} satisfies CustomPlaceholderTokens;
